import { render, staticRenderFns } from "./ProfileCompany.vue?vue&type=template&id=044d703c&"
import script from "./ProfileCompany.vue?vue&type=script&lang=ts&"
export * from "./ProfileCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports